import { TestMethodSuggestion } from "./test-method-suggestion.model";

export class Suggestion {
  isGenerateTestMethodGroup: boolean;
  testMethodGroupId?: number;
  testMethodGroupName?: string;
  testMethodSuggestions: TestMethodSuggestion[]
}
